// Centralized bilingual option lists {value, en, hi}
const o = (value, en, hi) => ({ value, en, hi });

export const WORKING_STATUS = [
  o("field_work", "Field Work", "फील्ड कार्य"),
  o("hq_work", "HQ Work", "मुख्यालय कार्य"),
  o("meeting", "Meeting", "बैठक"),
  o("training", "Training", "प्रशिक्षण"),
  o("leave", "Leave", "छुट्टी"),
  o("weekly_off", "Weekly Off", "साप्ताहिक अवकाश"),
  o("holiday", "Holiday", "अवकाश"),
];

export const WORKING_WITH = [
  o("alone", "Alone", "अकेले"),
  o("manager", "Manager", "प्रबंधक"),
  o("colleague", "Colleague", "सहकर्मी"),
  o("distributor_rep", "Distributor Rep", "वितरक प्रतिनिधि"),
  o("other", "Other", "अन्य"),
];

export const CALL_STATUS = [
  o("met_doctor", "Met Doctor", "डॉक्टर से मिले"),
  o("met_staff", "Met Clinic Staff", "स्टाफ से मिले"),
  o("unavailable", "Doctor Unavailable", "डॉक्टर अनुपलब्ध"),
  o("clinic_closed", "Clinic Closed", "क्लिनिक बंद"),
  o("appointment", "Appointment Requested", "अपॉइंटमेंट अनुरोध"),
];

export const CONTACT_RESULT = [
  o("contact_met", "Contact Met", "संपर्क से मिले"),
  o("contact_unavailable", "Contact Unavailable", "संपर्क अनुपलब्ध"),
  o("shop_closed", "Shop / Business Closed", "दुकान बंद"),
  o("followup_required", "Follow-up Required", "फॉलो-अप आवश्यक"),
];

export const DOCTOR_RESPONSE = [
  o("very_interested", "Very Interested", "बहुत रुचि"),
  o("interested", "Interested", "रुचि"),
  o("needs_info", "Needs More Info", "अधिक जानकारी चाहिए"),
  o("will_consider", "Will Consider", "विचार करेंगे"),
  o("other_brand", "Using Another Brand", "अन्य ब्रांड उपयोग"),
  o("price_concern", "Price Concern", "मूल्य चिंता"),
  o("not_interested", "Not Interested", "रुचि नहीं"),
];

export const RX_POTENTIAL = [
  o("high", "High", "उच्च"),
  o("medium", "Medium", "मध्यम"),
  o("low", "Low", "निम्न"),
  o("not_assessed", "Not Assessed", "मूल्यांकन नहीं"),
];

export const SAMPLE_TYPES = [
  o("nothing", "Nothing Given", "कुछ नहीं"),
  o("sample", "Product Sample", "उत्पाद सैंपल"),
  o("literature", "Literature", "साहित्य"),
  o("visual_aid", "Visual Aid", "विज़ुअल एड"),
  o("gift", "Reminder Gift", "उपहार"),
  o("other", "Other", "अन्य"),
];

export const FOLLOW_UP = [
  o("none", "No Follow-up", "फॉलो-अप नहीं"),
  o("7", "After 7 Days", "7 दिन बाद"),
  o("15", "After 15 Days", "15 दिन बाद"),
  o("30", "After 30 Days", "30 दिन बाद"),
];

export const RETAILER_PURPOSE = [
  o("intro", "Product Introduction", "उत्पाद परिचय"),
  o("order", "Order Booking", "ऑर्डर बुकिंग"),
  o("stock", "Stock Checking", "स्टॉक जांच"),
  o("payment", "Payment Collection", "भुगतान संग्रह"),
  o("followup", "Follow-up", "फॉलो-अप"),
  o("scheme", "Scheme Discussion", "स्कीम चर्चा"),
];

export const AVAILABILITY = [
  o("in_stock", "In Stock", "स्टॉक में"),
  o("low_stock", "Low", "कम"),
  o("out_of_stock", "Out", "समाप्त"),
  o("not_listed", "Not Listed", "सूचीबद्ध नहीं"),
  o("not_checked", "Not Checked", "जांचा नहीं"),
];

export const ORDER_RECEIVED = [
  o("yes", "Yes", "हाँ"),
  o("no", "No", "नहीं"),
  o("later", "Expected Later", "बाद में"),
];

export const RETAILER_RESPONSE = [
  o("very_positive", "Very Positive", "बहुत सकारात्मक"),
  o("positive", "Positive", "सकारात्मक"),
  o("neutral", "Neutral", "तटस्थ"),
  o("price_concern", "Price Concern", "मूल्य चिंता"),
  o("margin_concern", "Margin Concern", "मार्जिन चिंता"),
  o("low_demand", "Low Demand", "कम मांग"),
  o("needs_promo", "Needs Promo", "प्रचार चाहिए"),
  o("supply_problem", "Supply Problem", "आपूर्ति समस्या"),
  o("not_interested", "Not Interested", "रुचि नहीं"),
];

export const PAYMENT_COLLECTION = [
  o("none", "No Payment", "कोई भुगतान नहीं"),
  o("full", "Full Payment", "पूर्ण भुगतान"),
  o("partial", "Partial Payment", "आंशिक भुगतान"),
  o("promised", "Payment Promised", "भुगतान का वादा"),
  o("overdue", "Overdue", "अतिदेय"),
];

export const PAYMENT_METHOD = [
  o("cash", "Cash", "नकद"),
  o("upi", "UPI", "यूपीआई"),
  o("cheque", "Cheque", "चेक"),
  o("bank", "Bank Transfer", "बैंक ट्रांसफर"),
];

export const STOCKIST_PURPOSE = [
  o("stock", "Stock Checking", "स्टॉक जांच"),
  o("order", "Order Booking", "ऑर्डर बुकिंग"),
  o("payment", "Payment Collection", "भुगतान संग्रह"),
  o("supply", "Supply Issue", "आपूर्ति समस्या"),
  o("scheme", "Scheme Discussion", "स्कीम चर्चा"),
  o("return", "Return/Replacement", "वापसी/प्रतिस्थापन"),
  o("followup", "Routine Follow-up", "नियमित फॉलो-अप"),
];

export const STOCK_POSITION = [
  o("good", "Good Stock", "अच्छा स्टॉक"),
  o("low", "Low Stock", "कम स्टॉक"),
  o("out", "Out of Stock", "स्टॉक समाप्त"),
  o("excess", "Excess Stock", "अधिक स्टॉक"),
  o("not_checked", "Not Checked", "जांचा नहीं"),
];

export const COLLECTION_STATUS = [
  o("none", "No Collection", "कोई संग्रह नहीं"),
  o("full", "Full Collection", "पूर्ण संग्रह"),
  o("partial", "Partial Collection", "आंशिक संग्रह"),
  o("promised", "Payment Promised", "भुगतान का वादा"),
  o("overdue", "Overdue", "अतिदेय"),
];

export const SUPPORT_REQUIRED = [
  o("none", "No Support", "सहायता नहीं"),
  o("urgent_supply", "Urgent Supply", "तत्काल आपूर्ति"),
  o("promo", "Promo Materials", "प्रचार सामग्री"),
  o("replacement", "Replacement", "प्रतिस्थापन"),
  o("payment", "Payment Resolution", "भुगतान समाधान"),
  o("manager_visit", "Manager Visit", "प्रबंधक विज़िट"),
  o("scheme", "Scheme Clarification", "स्कीम स्पष्टीकरण"),
];

export const MARKET_FEEDBACK = [
  o("good_response", "Good Product Response", "अच्छी प्रतिक्रिया"),
  o("price_concern", "Price Concern", "मूल्य चिंता"),
  o("margin_concern", "Margin Concern", "मार्जिन चिंता"),
  o("unavailable", "Product Unavailable", "उत्पाद अनुपलब्ध"),
  o("competitor", "Competitor Activity", "प्रतिस्पर्धी गतिविधि"),
  o("promo_required", "Promo Required", "प्रचार आवश्यक"),
  o("supply_problem", "Supply Problem", "आपूर्ति समस्या"),
  o("no_feedback", "No Important Feedback", "कोई महत्वपूर्ण प्रतिक्रिया नहीं"),
];

export const DAY_STATUS = [
  o("achieved", "Target Achieved", "लक्ष्य प्राप्त"),
  o("partial", "Partially Achieved", "आंशिक रूप से प्राप्त"),
  o("not_achieved", "Not Achieved", "प्राप्त नहीं"),
];

export const MGMT_SUPPORT = [
  o("none", "No Support", "सहायता नहीं"),
  o("manager_visit", "Manager Visit", "प्रबंधक विज़िट"),
  o("training", "Product Training", "उत्पाद प्रशिक्षण"),
  o("promo", "Promo Materials", "प्रचार सामग्री"),
  o("stock", "Stock Support", "स्टॉक सहायता"),
  o("payment", "Payment Support", "भुगतान सहायता"),
];

export const EXPENSE_CATEGORIES = [
  o("Travel", "Travel", "यात्रा"),
  o("Food", "Food", "भोजन"),
  o("Parking", "Parking", "पार्किंग"),
  o("Toll", "Toll", "टोल"),
  o("Accommodation", "Accommodation", "आवास"),
  o("Public transport", "Public Transport", "सार्वजनिक परिवहन"),
  o("Other", "Other", "अन्य"),
];

export const SPECIALITIES = [
  "Orthopedic", "General Physician", "Pediatrician", "Gynecologist",
  "Physician", "Cardiologist", "Dermatologist", "ENT", "Surgeon", "Other",
];

export const label = (opt, lang) => (lang === "hi" ? opt.hi : opt.en);
